/**
 * The mystery slab team picked in the sidebar, sent with every Mystery Slabs request so the
 * server can show that team's batches and cards only. The server checks it against the user:
 * a team the user isn't in is refused, never quietly widened.
 *
 * Kept outside React because the fetch wrappers in services/api.ts are plain functions;
 * MysteryTeamProvider sets it while it renders, before any child query starts.
 */
export const MYSTERY_TEAM_HEADER = "X-Mystery-Team";

/** Header value an admin sends for "All teams". */
export const ALL_MYSTERY_TEAMS = "all";

let selectedTeam: string | null = null;

/** A team id, ALL_MYSTERY_TEAMS, or null to send nothing (the region has no teams, or not loaded yet). */
export const setMysteryTeamHeader = (value: string | null) => {
  selectedTeam = value;
};

export const getMysteryTeamHeader = () => selectedTeam;

/** Only the Mystery Slabs endpoints (and the mystery slab log) read it, so only they get it. */
const MYSTERY_ENDPOINT = /\/mystery-slabs(\/|\?|$)/;

export const mysteryTeamHeaders = (endpoint: string): Record<string, string> =>
  selectedTeam && MYSTERY_ENDPOINT.test(endpoint) ? { [MYSTERY_TEAM_HEADER]: selectedTeam } : {};
